import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography, List, ListItem, ListItemText, ListItemIcon, IconButton } from '@material-ui/core';
import Icon from '../../../../Icon';
import Button from '../../../../Button';
import { useDashboardDispatch } from '../context/dashboardContext';
import InsertDialog from '../Insert/InsertDialog';
var useStyles = makeStyles(function (theme) {
  return {
    disabledText: {
      color: theme.palette.text.hint
    },
    visualizationButtons: {
      justifyContent: 'flex-start'
    },
    listIcon: {
      marginRight: theme.spacing(1),
      fontSize: 14
    },
    list: {
      margin: theme.spacing(0, -3)
    },
    listItem: {
      height: 34,
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(2)
    },
    root: {
      '&:hover': {
        '& $icon': {
          display: 'inline-block'
        }
      }
    },
    icon: {
      display: 'none',
      fontSize: 14
    }
  };
}, {
  name: 'ECVisualizations'
});

var InsertButton = function InsertButton(_ref) {
  var type = _ref.type,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var classes = useStyles({});
  return React.createElement(Button, {
    icon: type,
    color: "inherit",
    variant: "text",
    onClick: onClick,
    disabled: disabled,
    className: classes.visualizationButtons
  }, label);
};

var setWidgetIcon = function setWidgetIcon(type) {
  if (type.includes('table')) return 'table';else if (type.includes('gauge')) return 'gauge';else if (type.includes('pie')) return 'pie';else if (type.includes('line')) return 'line-chart';else if (type.includes('column')) return 'column-chart';else if (type.includes('bar')) return 'bar-chart';else return 'area-chart';
};

var Visualizations = function Visualizations(_ref2) {
  var widgets = _ref2.widgets,
      onSelectWidgetId = _ref2.onSelectWidgetId,
      selectedWidgetId = _ref2.selectedWidgetId,
      onEdit = _ref2.onEdit;
  var classes = useStyles({});

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dialog = _useState2[0],
      setDialog = _useState2[1];

  var dashboardDispath = useDashboardDispatch();
  return React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    height: "100%",
    px: 3,
    py: 2
  }, React.createElement(Box, {
    flex: "0 0 36%"
  }, React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 2
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, "Visualizations"), React.createElement(Typography, {
    className: classes.disabledText
  }, "Click to add a new visualization")), React.createElement(Grid, {
    item: true
  }, React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(InsertButton, {
    type: "area-chart",
    label: "Area",
    onClick: function onClick() {
      setDialog({
        type: 'areaChart',
        actionType: 'insert_chart'
      });
    }
  })), React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(InsertButton, {
    type: "table",
    label: "Table",
    onClick: function onClick() {
      setDialog({
        type: 'table',
        actionType: 'insert_table'
      });
    }
  })), React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(InsertButton, {
    type: "column-chart",
    label: "Column",
    onClick: function onClick() {
      setDialog({
        type: 'columnChart',
        actionType: 'insert_chart'
      });
    }
  })), React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(InsertButton, {
    type: "bar-chart",
    label: "Bar",
    onClick: function onClick() {
      setDialog({
        type: 'barChart',
        actionType: 'insert_chart'
      });
    }
  })), React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(InsertButton, {
    type: "line-chart",
    label: "Line",
    onClick: function onClick() {
      setDialog({
        type: 'lineChart',
        actionType: 'insert_chart'
      });
    }
  })), React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(InsertButton, {
    type: "gauge",
    label: "Gauge",
    onClick: function onClick() {
      setDialog({
        type: 'gauge',
        actionType: 'insert_gauge'
      });
    }
  })), React.createElement(Grid, {
    item: true,
    xs: 6
  }, React.createElement(InsertButton, {
    type: "pie",
    label: "Pie",
    onClick: function onClick() {
      setDialog({
        type: 'pieChart',
        actionType: 'insert_chart'
      });
    }
  })))))), React.createElement("div", null, React.createElement(Typography, {
    variant: "h6"
  }, "Content"), React.createElement(List, {
    className: classes.list,
    dense: true
  }, widgets.map(function (widget) {
    return React.createElement(ListItem, {
      key: widget.id,
      button: true,
      selected: widget.id === selectedWidgetId,
      className: classes.listItem + ' ' + classes.root,
      onClick: function onClick() {
        return onSelectWidgetId(widget.id);
      }
    }, React.createElement(ListItemIcon, null, React.createElement(Icon, {
      type: setWidgetIcon(widget.type.toLowerCase()),
      className: classes.listIcon
    })), React.createElement(ListItemText, {
      disableTypography: true
    }, React.createElement(Typography, {
      noWrap: true
    }, widget.name)), React.createElement(Icon, {
      type: "style",
      className: classes.icon,
      onClick: onEdit,
      buttonSize: "small"
    }));
  }))), dialog !== null && React.createElement(InsertDialog, {
    type: dialog.type,
    onSubmit: function onSubmit(chart) {
      dashboardDispath({
        type: dialog.actionType,
        payload: _objectSpread({
          type: dialog.type
        }, chart)
      });
      onSelectWidgetId(chart.id);
    },
    onClose: function onClose() {
      return setDialog(null);
    }
  }));
};

export default Visualizations;